export default __webpack_public_path__ + "a00625b574ae3f6641d889b9e2d240ce.png";